module.exports = __webpack_public_path__ + "img/w76b.ec4926b5.jpg";